<!--
 * @Description: 
 * @Author: xxx
 * @Date: 2022-01-11 15:49:19
 * @LastEditTime: 2022-01-13 13:35:37
 * @LastEditors: xxx
-->

<template>
  <div v-bind="returnTag(to)" class="targs">
    <slot />
  </div>
</template>

<script>
import { isAbsolutePath } from "@/utils/validate";
export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    returnTag(path) {
      console.log("path>>>>>", path, isAbsolutePath(path));
      if (isAbsolutePath(path) || path == "/map/company") {
        console.log("is a herf");
        return {
          is: "a",
          target: "_blank",
          href: "/#" + path
        };
      } else {
        return {
          is: "router-link",
          to: path
        };
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/sideBar/Link.vue